module.exports = __webpack_public_path__ + "img/25-consultas-fiscais-mapa.29b3d5a9.png";